import { __decorate, __metadata } from "tslib";
import { elementDefine, onConnectedBodyShadow, addEventListener, onInitialize, onConnectedBefore, innerHtml, attribute } from "@dooboostore/simple-web-component";
import { Router } from '@dooboostore/core-web';
const tagName = 'center-home-page';
export default (w) => {
    var _a, _b, _c;
    const existing = w.customElements.get(tagName);
    if (existing)
        return tagName;
    const apps = [
        {
            id: 'english',
            icon: '🎬',
            title: 'English Learning',
            description: 'YouTube 영상으로 영어를 배워보세요. 자막, 사전, 발음 연습까지.',
            path: '/english',
            color: '#ff0000',
            badge: 'Popular'
        },
        {
            id: 'text-english',
            icon: '📖',
            title: 'Text English',
            description: 'PDF·텍스트를 책처럼 읽으며 배우세요. 단어 툴팁, 발음 듣기까지.',
            path: '/text-english',
            color: '#4e342e',
            badge: 'New'
        },
        {
            id: 'stock-flight',
            icon: '✈️',
            title: 'Stock Flight',
            description: '주식 데이터를 비행기 계기판처럼 시각화하여 한눈에 파악하세요.',
            path: '/stock-flight',
            color: '#2196f3',
            badge: 'New'
        },
        {
            id: 'lotto',
            icon: '🎰',
            title: 'Lotto Analytics',
            description: '로또 당첨 번호 분석 및 통계 데이터를 시각적으로 확인하세요.',
            path: '/lotto',
            color: '#ff9800',
            badge: 'New'
        },
        {
            id: 'coordinate-simulation',
            icon: '📐',
            title: '2D Coordinate Simulation',
            description: '2D 좌표계를 시각화하고 FPS를 조절하며 시뮬레이션해보세요.',
            path: '/coordinate-simulation',
            color: '#9c27b0',
            badge: ''
        },
        {
            id: 'buyback',
            icon: '💼',
            title: '자사주 매입 신청',
            description: 'SK하이닉스, 삼성전자 자사주 매입신청 현황을 확인하세요.',
            path: '/buyback',
            color: '#1976d2',
            badge: 'New'
        },
        {
            id: 'stock-brain-checker',
            icon: '🧠',
            title: '뇌동매매 잠깐!',
            description: '팔까? 살까? Y/N 체크로 뇌동매매를 막아보세요.',
            path: '/stock-brain-checker',
            color: '#ef4444',
            badge: 'New'
        },
        {
            id: 'stock-npti',
            icon: '🧬',
            title: '주식 NPTI',
            description: '내 종목의 MBTI는? 6각 레이더와 50봉 궤적으로 성격을 분석해보세요.',
            path: '/stock-npti',
            color: '#6366f1',
            badge: 'New'
        },
        {
            id: 'stock-category-ranking',
            icon: '📊',
            title: '카테고리 랭킹',
            description: '국내/해외 TICS 카테고리별 등락률·거래대금·시가총액 분포도를 한눈에 비교하세요.',
            path: '/stock-category-ranking',
            color: '#0ea5e9',
            badge: 'New'
        },
        {
            id: 'stock-category',
            icon: '🗂️',
            title: '종목 카테고리',
            description: 'TICS 카테고리를 검색하고 클릭하면 구성종목을 확인하세요.',
            path: '/stock-category',
            color: '#14b8a6',
            badge: 'New'
        },
        {
            id: 'stock-indicator',
            icon: '📈',
            title: '주요 지표',
            description: '코스피·나스닥·환율·금리 등 주요 지표를 한눈에 확인하세요.',
            path: '/stock-indicator',
            color: '#7c3aed',
            badge: 'New'
        },
        {
            id: 'stock-chart',
            icon: '📉',
            title: '종목 차트',
            description: '종목 검색 후 일봉 차트를 확인하세요.',
            path: '/stock-chart',
            color: '#0288d1',
            badge: 'New'
        },
        {
            id: 'gpu-rental',
            icon: '🎮',
            title: 'GPU 렌탈 시세',
            description: 'vast.ai GPU 시간당 렌탈료를 한눈에 확인하세요.',
            path: '/gpu-rental',
            color: '#6d28d9',
            badge: 'New'
        },
        {
            id: 'stock-trading-simulation',
            icon: '📈',
            title: '가상 트레이딩',
            description: '종목 검색 후 1년 일봉 차트로 가상 매매를 시뮬레이션해보세요.',
            path: '/stock-trading-simulation',
            color: '#f59e0b',
            badge: 'New'
        },
        {
            id: 'math',
            icon: '📐',
            title: '수학 그래프',
            description: '삼각함수·이차함수·지수/로그·정규분포를 그래프로 시각화해보세요.',
            path: '/math',
            color: '#6366f1',
            badge: 'New'
        },
        {
            id: 'physical',
            icon: '🦾',
            title: '피지컬 AI 개념',
            description: '기어비·IMU·자유도 등 로봇·피지컬 AI에서 쓰는 하드웨어·센서·역학 개념을 그래프로 시각화해보세요.',
            path: '/physical',
            color: '#0f766e',
            badge: 'New'
        },
        {
            id: 'vision',
            icon: '👁️',
            title: '비전 개념',
            description: '영상처리·로보틱스 비전 개념을 그래프와 인터랙션으로 시각화해보세요.',
            path: '/vision',
            color: '#0369a1',
            badge: 'New'
        },
        {
            id: 'ros2',
            icon: '🤖',
            title: 'ROS 2 개념',
            description: 'ROS 2를 설치부터 노드·통신·DDS·TF까지 인터랙션으로 배워보세요.',
            path: '/ros2',
            color: '#22314e',
            badge: 'New'
        },
        {
            id: 'ai',
            icon: '🧠',
            title: 'AI 개념',
            description: '로봇 AI 결합 위치와 Sim2Real을 인터랙션으로 배워보세요.',
            path: '/ai',
            color: '#4c1d95',
            badge: 'New'
        },
        {
            id: 'ram-price',
            icon: '💾',
            title: '반도체 RAM 가격 추이',
            description: 'DDR5·DDR4·LPDDR5·HBM3E 등 반도체 메모리 칩 가격 추이를 한눈에 확인하세요.',
            path: '/ram-price',
            color: '#1a237e',
            badge: 'New'
        }
    ];
    let HomePage = class HomePage extends w.HTMLElement {
        constructor() {
            super(...arguments);
            Object.defineProperty(this, "router", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
        }
        setPageMeta() {
            return {
                titleBody: "@dooboostore Center",
                ogTitle: "@dooboostore Center",
                desc: "다양한 미니 앱들을 한 곳에서 만나보세요.",
                ogDesc: "다양한 미니 앱들을 한 곳에서 만나보세요.",
            };
        }
        onInitialized(router) {
            this.router = router;
        }
        render() {
            const cardHtml = apps.map(app => `
        <div class="app-card" data-path="${app.path}" role="button" tabindex="0" aria-label="${app.title}">
          ${app.badge ? `<span class="badge">${app.badge}</span>` : ''}
          <div class="card-icon" style="background: ${app.color}20; color: ${app.color}">
            ${app.icon}
          </div>
          <div class="card-body">
            <h3 class="card-title">${app.title}</h3>
            <p class="card-desc">${app.description}</p>
          </div>
          <div class="card-arrow">
            <i class="fas fa-arrow-right"></i>
          </div>
        </div>
      `).join('');
            return `
        <style>
          *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
          :host {
            display: block;
            min-height: 100vh;
            background: var(--color-bg, #fff);
            font-family: var(--font-family, -apple-system, sans-serif);
            color: var(--color-text, #222);
          }

          .hero {
            background: linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%);
            color: white;
            padding: 80px 40px 60px;
            text-align: center;
          }

          .hero-logo {
            width: 72px;
            height: 72px;
            border-radius: 20px;
            margin: 0 auto 24px;
            overflow: hidden;
            box-shadow: 0 8px 24px rgba(0,0,0,0.2);
          }

          .hero-logo img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          .hero h1 {
            font-size: 42px;
            font-weight: 850;
            letter-spacing: -1.5px;
            margin-bottom: 16px;
            line-height: 1.1;
          }

          .hero p {
            font-size: 18px;
            opacity: 0.85;
            max-width: 560px;
            margin: 0 auto;
            line-height: 1.6;
          }

          .main {
            max-width: 960px;
            margin: 0 auto;
            padding: 60px 24px 80px;
          }

          .section-title {
            font-size: 22px;
            font-weight: 700;
            color: var(--color-text, #222);
            margin-bottom: 28px;
            display: flex;
            align-items: center;
            gap: 10px;
          }

          .section-title::after {
            content: '';
            flex: 1;
            height: 1px;
            background: var(--color-border, #e0e0e0);
          }

          .apps-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
            gap: 20px;
          }

          .app-card {
            position: relative;
            background: var(--color-surface, #fff);
            border: 1px solid var(--color-border, #e0e0e0);
            border-radius: 16px;
            padding: 24px;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 16px;
            outline: none;
          }

          .app-card:hover {
            border-color: var(--color-primary, #1976d2);
            box-shadow: 0 8px 24px rgba(25, 118, 210, 0.12);
            transform: translateY(-2px);
          }

          .app-card:focus-visible {
            border-color: var(--color-primary, #1976d2);
            box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.2);
          }

          .badge {
            position: absolute;
            top: 12px;
            right: 12px;
            background: var(--color-secondary, #ff385c);
            color: white;
            font-size: 10px;
            font-weight: 700;
            padding: 3px 8px;
            border-radius: 999px;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .card-icon {
            width: 56px;
            height: 56px;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            flex-shrink: 0;
          }

          .card-body {
            flex: 1;
            min-width: 0;
          }

          .card-title {
            font-size: 16px;
            font-weight: 700;
            color: var(--color-text, #222);
            margin-bottom: 6px;
          }

          .card-desc {
            font-size: 13px;
            color: var(--color-text-muted, #888);
            line-height: 1.5;
          }

          .card-arrow {
            color: var(--color-text-light, #aaa);
            font-size: 14px;
            flex-shrink: 0;
            transition: transform 0.2s ease, color 0.2s ease;
          }

          .app-card:hover .card-arrow {
            color: var(--color-primary, #1976d2);
            transform: translateX(4px);
          }

          .coming-soon {
            text-align: center;
            padding: 48px 24px;
            color: var(--color-text-muted, #888);
            border: 2px dashed var(--color-border, #e0e0e0);
            border-radius: 16px;
            margin-top: 20px;
          }

          .coming-soon .icon { font-size: 40px; margin-bottom: 12px; }
          .coming-soon p { font-size: 15px; }

          footer {
            text-align: center;
            padding: 32px 24px;
            border-top: 1px solid var(--color-border, #e0e0e0);
            color: var(--color-text-muted, #888);
            font-size: 13px;
          }

          @media (max-width: 600px) {
            .hero { padding: 60px 20px 40px; }
            .hero h1 { font-size: 28px; }
            .hero p { font-size: 15px; }
            .main { padding: 40px 16px 60px; }
            .apps-grid { grid-template-columns: 1fr; }
          }
        </style>

        <div class="hero">
          <div class="hero-logo">
            <img src="/assets/dooboostore.png" alt="dooboostore logo">
          </div>
          <h1>dooboostore</h1>
          <p>다양한 미니 앱들을 한 곳에서 만나보세요.</p>
          <div><img alt="Hits" src="https://hits.sh/hits.sh/dooboostore.github.io.svg?style=plastic&amp;"></div>
        </div>

        <main class="main">
          <h2 class="section-title">Apps</h2>
          <div class="apps-grid">
            ${cardHtml}
          </div>
          <div class="coming-soon">
            <div class="icon">🚀</div>
            <p>더 많은 앱들이 곧 추가될 예정입니다.</p>
          </div>
        </main>

        <footer>
          © 2025 dooboostore · Built with @dooboostore/simple-web-component
        </footer>
      `;
        }
        onCardClick(e) {
            const card = e.target.closest('.app-card');
            if (card?.dataset.path) {
                this.router?.go(card.dataset.path);
                // window.location.href = card.dataset.path;
            }
        }
        onCardKeydown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const card = e.target.closest('.app-card');
                if (card?.dataset.path) {
                    this.router?.go(card.dataset.path);
                    // window.location.href = card.dataset.path;
                }
            }
        }
    };
    __decorate([
        onConnectedBefore,
        innerHtml((c, helper) => helper.$w.document.querySelector("title"), { valueKey: "titleBody" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:title"]'), "content", { valueKey: "ogTitle" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[name="description"]'), "content", { valueKey: "desc" }),
        attribute((c, helper) => helper.$w.document.querySelector('meta[property="og:description"]'), "content", { valueKey: "ogDesc" }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HomePage.prototype, "setPageMeta", null);
    __decorate([
        onInitialize,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof Router !== "undefined" && Router) === "function" ? _a : Object]),
        __metadata("design:returntype", void 0)
    ], HomePage.prototype, "onInitialized", null);
    __decorate([
        onConnectedBodyShadow,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], HomePage.prototype, "render", null);
    __decorate([
        addEventListener('.app-card', 'click', { delegate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_b = typeof Event !== "undefined" && Event) === "function" ? _b : Object]),
        __metadata("design:returntype", void 0)
    ], HomePage.prototype, "onCardClick", null);
    __decorate([
        addEventListener('.app-card', 'keydown', { delegate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof KeyboardEvent !== "undefined" && KeyboardEvent) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], HomePage.prototype, "onCardKeydown", null);
    HomePage = __decorate([
        elementDefine(tagName, { window: w })
    ], HomePage);
    return tagName;
};
